import { Action } from 'redux';
import { CheckoutActionTypes } from '../../checkout.types';
import { ACTION_CREATOR_NAME } from 'helpers';

export interface RemoveAddressSearchEditorAction extends Action<CheckoutActionTypes.REMOVE_ADDRESS_SEARCH_EDITOR> {
    addressSearchEditorId: string;
}

export const removeAddressSearchEditor: (addressSearchEditorId: string) => RemoveAddressSearchEditorAction = (addressSearchEditorId: string) => ({
    type: CheckoutActionTypes.REMOVE_ADDRESS_SEARCH_EDITOR,
    addressSearchEditorId
});
removeAddressSearchEditor[ACTION_CREATOR_NAME] = 'removeAddressSearchEditor';

export type RemoveAddressSearchEditorFunc = (...args: Parameters<typeof removeAddressSearchEditor>) => void;
